import { render } from "./EventView.vue?vue&type=template&id=1242e86e"
import script from "./EventView.vue?vue&type=script&lang=js"
export * from "./EventView.vue?vue&type=script&lang=js"

import "./EventView.vue?vue&type=style&index=0&id=1242e86e&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__